module.exports = __webpack_public_path__ + "static/media/bell-tower.c4b46499.jpg";